<template>
    <div class="answers-page-owners">
        <answersList :listData="questionsPage.q_owners" v-if="!isMobileChecker"></answersList>
        <answersListMobile :listData="questionsPage.q_owners" v-else></answersListMobile>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import answersList from '@/components/answers-page/answers-list.vue';
    import answersListMobile from '@/components/answers-page/answers-list-mobile.vue';
    export default {
        name: 'answers-owners',
        components: {
            answersList,
            answersListMobile,
            // svgIcon,
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            questionsPage: 'loadQuestionsPage',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    // @import '@/styles/components/about-page/awards-section.scss';
    // @import '@/styles/components/about-page/respond/awards-section-respond.scss';
</style>